{
  "backButton": "Atgriezties uz {prevMenuButton}",
  "moreActions": "Citas darbības",
  "unavailable": "Nav pieejams, izvērsiet, lai skatītu sīkāku informāciju"
}
